import React, { useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { AnimatedModal, PaymentModal } from "..";

const CoinPricing = (props) => {

    return (
        <div className={styles.container}>
        <div className={styles.header}>
    <h1>Combine Coins With Our Subscription Plans</h1>
    <p style={{color: 'hsl(234, 14%, 74%)'}}>Enjoy the best prices on the market with huge discounts for annual purchases</p>
    <div className={styles["toggle"]}>
      <label>Annually </label>
      <div className={styles["toggle-btn"]}>
        <input checked={props.currentYearly} onChange={() => props.setCurrentYearly(!props.currentYearly)} type="checkbox" className={styles["checkbox"]} id={styles.checkbox} />
        <label className={styles["sub"]} id={styles.sub} for="checkbox">
          <div className={styles["circle"]}></div>
        </label>
      </div>
      <label> Monthly</label>
    </div>
  </div>
  <div className={styles["cards"]}>
    <div className={`${styles["card"]} ${styles["shadow"]}`}>
      <ul>
        <li className={styles["pack"]}>Basic</li>
        <li id={styles.basic} className={`${styles["price"]} ${styles["bottom-bar"]}`}>{!props.currentYearly ? '$20.50' : '26$'} <span style={{transform: 'translateY(50px)'}} className="absolute text-lg">+20,000 Coins</span></li>
        <li className={styles["bottom-bar"]}>10MN/s Stockfish Analysis</li>
        <li className={styles["bottom-bar"]}>10MB Cloud Storage</li>
        <li className={styles["bottom-bar"]}>5.4M+ Master Games</li>
        <li className={styles["bottom-bar"]}>Millions Evaluated Positions</li>
        <li onClick={() => { props.setCurrentPlan(0); props.reference.current.click();}}><button className={styles["btn"]}>Buy Now</button></li>
      </ul>
    </div>
    <div className={`${styles["card"]} ${styles["active"]}`}>
      <ul>
        <li className={styles["pack"]}>Professional</li>
        <li id={styles.professional} className={`${styles["price"]} ${styles["bottom-bar"]}`}>{!props.currentYearly ? '$58' : '$75'} <span style={{transform: 'translateY(50px)'}} className="absolute text-lg">+50,000 Coins</span></li>
        <li className={styles["bottom-bar"]}>30MN/s Stockfish Analysis</li>
        <li className={styles["bottom-bar"]}>100MB Cloud Storage</li>
        <li className={styles["bottom-bar"]}>5.4M+ Master Games</li>
        <li className={styles["bottom-bar"]}>Millions Evaluated Positions</li>
        <li className={styles["bottom-bar"]}>Unlimited Variations Download</li>
        <li onClick={() => {props.setCurrentPlan(1); props.reference.current.click();}}><button className={`${styles["btn"]} ${styles["active-btn"]}`}>Buy Now</button></li>
      </ul>
    </div>
    <div className={`${styles["card"]} ${styles["shadow"]}`}>
      <ul>
        <li className={styles["pack"]}>Master</li>
        <li id={styles.master} className={`${styles["price"]} ${styles["bottom-bar"]}`}>{!props.currentYearly ? '$103' : '$180'} <span style={{transform: 'translateY(50px)'}} className="absolute text-lg">+100,000 Coins</span></li>
        <li className={styles["bottom-bar"]}>100MN/s Stockfish Analysis</li>
        <li className={styles["bottom-bar"]}>Unlimited Cloud Storage</li>
        <li className={styles["bottom-bar"]}>5.4M+ Master Games</li>
        <li className={styles["bottom-bar"]}>Millions Evaluated Positions</li>
        <li className={styles["bottom-bar"]}>Unlimited Variations Download</li>
        <li onClick={() => {props.setCurrentPlan(2); props.reference.current.click();}}><button className={styles["btn"]}>Buy Now</button></li>
      </ul>
    </div>
  </div>
  </div>
    )
}

export default CoinPricing;